<template>
  <div>
    <div v-if="$isMobile" style="width: 100%; overflow-x: hidden">
      <v-card :max-width="$isTablet ? (windowInnerWidth * 0.6) : (windowInnerWidth * 0.95 - 20)" class="mobile-main">
        <v-card-text class='position-relative pa-3'>
          <div class='mb-2 font-weight-bold' style="color: #333;">
            {{ title }}
          </div>
          <div v-if='dataList.length > 0' style="width: 100%;"
               class='mt-4 d-flex align-center justify-space-between flex-wrap'>
            <v-card
              class="mb-2 city-item"
              v-for='(item, index) in dataList'
              :key='index'
              :style="{opacity: messageData.cityDisabled ? item.radioValue ? 1 : 0.4 : 1}"
              @click.native='radioChange(item)'
            >
              <span
                class="city-name"
                @click.stop='radioChange(item)'
              >
                  {{ language === 'chinese' ? item.aliasName : item.cityName }}
                </span>
              <v-img
                style="width: 100%"
                :src='require(`@/assets/images/mobile/sel_${item.cityName}.jpg`)'
              >
              </v-img>
            </v-card>
          </div>
          <div v-if='dataList.length === 0' class='text-center mt-3 mb-2'>
            {{ language === 'chinese' ? '暂无数据' : 'No data available.' }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            :disabled='messageData.cityDisabled'
            depressed
            small
            @click="$emit('cancelChat', {language}); messageData.cityDisabled = true"
          >
            {{ language === 'chinese' ? '取消' : 'Cancel' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <div v-else>
      <v-card max-width='730' elevation="5" style='border: none; background: #f3f4f6'>
        <v-card-text class='position-relative pb-0' style=''>
          <div class='mb-2 font-weight-bold'>
            {{ title }}
          </div>
          <div v-if='dataList.length > 0' class='mt-4 d-flex align-center flex-wrap'>
            <v-card
              v-for='(item, index) in dataList'
              :class="[(index + 1) % 3 === 0 ? '': 'mr-4', 'mb-4', 'cursor-pointer']"
              :key='index'
              width='219'
              @click.native='radioChange(item)'
            >
              <v-card-title class='pb-4 d-flex align-center justify-space-between pa-4'>
                <div class='d-inline-block text-truncate' style='width: 80%; line-height: 23px'>
                  <span style='font-size: 17px; color: #000'>
                    {{ language === 'chinese' ? item.aliasName : item.cityName }}
                  </span>
                </div>
                <radio-circle
                  :value='item.radioValue'
                  :disabled='messageData.cityDisabled'
                  @click.native.stop='radioChange(item)'
                >
                </radio-circle>
              </v-card-title>
              <v-img
                height='120'
                :src='require(`@/assets/images/city/sel_${item.cityName}.png`)'
              >
              </v-img>
            </v-card>
          </div>
          <div v-if='dataList.length === 0' class='text-center mt-3 mb-2'>
            {{ language === 'chinese' ? '暂无数据' : 'No data available.' }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            :disabled='messageData.cityDisabled'
            depressed
            small
            @click="$emit('cancelChat', {language}); messageData.cityDisabled = true"
          >
            {{ language === 'chinese' ? '取消' : 'Cancel' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <message-box
      :msg-id='msgId'
      class='mt-2'
      @copy='copy'
      :message='messageData'
      :like-type='messageData.likeType'
      :isCustomCopyWriteText='true'
      @refreshAnswer="$emit('refreshAnswer', messageData)"
    ></message-box>
  </div>
</template>

<script>
import MessageBox from '../components/MessageBox.vue'
import { PageHandle } from '@/modules/chat/util/ChatBotUtil'
import RadioCircle from '../components/RadioCircle.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'bookSeatCardList',
  components: { MessageBox, RadioCircle },
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    msgId: {
      type: Number,
      default: 0,
    },
    messageData: {
      type: Object,
      default: () => {
      },
    },
    immediatelyRender: {
      type: Boolean,
      default: false,
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  watch: {
    list: {
      handler(val) {
        this.pageHandleMethod(val)
      },
      immediate: true,
    },
    language: {
      handler(val) {
        this.title = val === 'chinese' ? '请您选择所在城市' : 'Please select your city'
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      chatSessionId: 'chat/chatSessionId',
      modelType: 'chat/modelType',
    }),
    windowInnerWidth() {
      return window.innerWidth
    },
    citySelected() {
      return this.dataList.some(item => item.radioValue)
    },
  },
  data() {
    return {
      messages: '',
      showTable: false,
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      title: '请您选择所在城市',
      pageOption: {
        page: 1,
        total: 0,
        size: 12,
        length: 0,
      },
      dataList: [],
      pageHandle: null,
    }
  },
  async mounted() {
    if (this.messageData.tipMsg) {
      this.title = this.messageData.tipMsg
    }
    if (!this.immediatelyRender) {
      await this.displayMessageCharacterByCharacter(this.title)
    } else {
      this.showTable = true
    }
  },
  methods: {
    pageHandleMethod(valList = this.list) {
      this.pageHandle = new PageHandle(valList, this.pageOption.page, this.pageOption.size)
      this.pageOption.length = this.pageHandle.getPages()
      this.dataList = this.pageHandle.getCurrentPageList()
      this.dataList.forEach(item => {
        item.radioValue = false
      })
      this.componentInitSet()
    },
    componentInitSet() {
      if (this.messageData.componentSelectionValue) {
        const componentSelectionValue = JSON.parse(this.messageData.componentSelectionValue)
        if (componentSelectionValue) {
          this.dataList.forEach(el => {
            this.$set(el, 'radioValue', componentSelectionValue.cityName === el.cityName)
          })
        }
      }
    },
    radioChange(item) {
      if (this.messageData.cityDisabled) {
        return
      }
      this.$set(this.messageData, 'cityDisabled', this.modelType === 'DeepSeek')
      this.dataList.forEach(el => {
        this.$set(el, 'radioValue', item.cityId === el.cityId)
      })
      this.$forceUpdate()
      this.$emit('selectCityChange', { ...item, answerId: this.msgId })
    },
    pageChange() {
      this.pageHandleMethod()
    },
    async copy() {
      let copyTemplate = '城市\t\t\n'
      const startIndex = (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage
      const endIndex = startIndex + this.tableOptions.itemsPerPage
      this.list.slice(startIndex, endIndex).forEach(item => {
        copyTemplate = copyTemplate + item.cityName + '\t\n'
      })
      await navigator.clipboard.writeText(copyTemplate)
      this.$message.success('复制成功')
    },
    displayMessageCharacterByCharacter(text) {
      var char = text.split('')
      for (let i = 0; i < char.length; i++) {
        setTimeout(() => {
          this.messages += char[i]
          this.$forceUpdate() // 强制视图更新以显示最新文本
          // this.scrollToBottom() // 确保新消息可见
        }, i * 150) // 1秒间隔
      }
      setTimeout(() => {
        this.showTable = true
        this.$emit('renderTableComplete')
      }, 2100)
      // this.showTable = true
    },
    // 预定按钮点击事件
    reserve(item) {
      // 拼接参数到 URL
      const url = `https://support-places.accenture.com/places?id=places_reservation_form&building=${encodeURIComponent(item.buildingId)}&start=${encodeURIComponent(item.startTime)}&end=${encodeURIComponent(item.endTime)}&floor=${encodeURIComponent(item.floorId)}&goback=goback&reservable_ids=${encodeURIComponent(item.roomId)}&timezone=Asia%2FShanghai&primary_building=${encodeURIComponent(item.buildingId)}&neighborhood=&reservation_path=browse_all&ignore_same_day_validation=false&all_day=false&reservable_module=${(item.reservableModule)}`
      window.location.href = url // 跳转到带参数的 URL
    },
  },
}
</script>

<style scoped>
.mobile-main {
  width: 100%;
  height: auto;
  overflow: hidden;
  border-radius: 0 12px 2px 2px;
  background: #f8f5fd;
  border: none !important;
}

.city-item {
  width: 32%;
  border-radius: 10px;
  background: #44ac9b82;
  opacity: 1;
}

.city-name {
  position: absolute;
  margin: 0;
  top: 50%;
  left: 50%;
  z-index: 10;
  transform: translate(-50%, -50%);
  font-weight: 700;
  font-size: 24px;
  color: #fff;
}
</style>
